import React from "react";
import { DashboardContentValue } from "../../components/dashboard/DashboardContentValue";
import { DashboardData } from "../../types/dashboardData";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { PureNumberDashboardCard } from "../../components/dashboard/PureNumberDashboardCard";
import { useCustomTranslation } from "../../provider/useCustomTranslation";

export function CouponsCard(props: { data: DashboardData }) {
  const { data } = props;
  const { t } = useCustomTranslation();
  return (
    <PureNumberDashboardCard
      gridProps={{ xs: 12, md: data.coins ? 6 : 4 }}
      title={t("pages.dashboard.activeCoupons")}
      icon={<ConfirmationNumberIcon fontSize={"large"} color={"primary"} />}
      resource={"coupon-types"}
    >
      <DashboardContentValue value={data.coupons.activeCoupons} />
    </PureNumberDashboardCard>
  );
}
